export default function formatDuration(milliseconds) {
  if (milliseconds == null) return '—'
  if (milliseconds < 1000) return `${milliseconds} ms`

  const seconds = Math.round(milliseconds / 1000)
  if (seconds < 60) return `${seconds} s`

  const minutes = Math.floor(seconds / 60)
  const remaining = seconds % 60
  return remaining ? `${minutes} m ${remaining} s` : `${minutes} m`
}
